import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useProductFamilies(establishmentId) {
  const queryReturnValues = useQuery(
    ["product-families", { establishmentId }],
    inventoryClient.getProductFamiliesReactQuery,
    {
      staleTime: 1000 * 60,
    }
  );

  return queryReturnValues;
}

export default useProductFamilies;
